import { twMerge } from 'src/utils/tw-merge.util'

type TMedicalCommentDividerProps = {
  date: string
}

const MedicalTeamCommentListDivider = ({ date }: TMedicalCommentDividerProps) => {
  return (
    <div
      className={twMerge(
        'c-w-full c-flex c-border-l-2 c-border-l-transparent c-bg-blue-300 c-rounded-md c-mt-2 c-mb-6',
      )}
    >
      <span className="c-min-w-fit c-flex c-flex-row c-items-center c-rounded-md c-px-4 c-py-1 c-font-semibold c-text-sm c-text-primary-900">
        {date}
      </span>
    </div>
  )
}

export default MedicalTeamCommentListDivider
